import React from "react";
import Women1 from "../../images/My-landing-img1.png";

const InstantBilling = () => {
  return (
    <div className="page-wrap bg-white py-16 px-6">
      <div className="section-inner max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-16">
        {/* LEFT */}
        <div className="left-box flex-1 flex justify-center">
          <img
            src={Women1}
            alt="marketing"
            className="main-img w-full max-w-[500px]"
          />
        </div>

        {/* RIGHT */}
        <div className="right-box flex-1">
          <h1 className="montserrat-font-1 relax-title text-3xl md:text-4xl font-semibold text-[#0C4D45] mb-6">
            Instant Billing, Stress Free Service
          </h1>

          <p className="montserrat-font-2 relax-description text-gray-600 leading-relaxed mb-8">
            With Anlook’s smart POS system, you can generate bills in seconds
            and keep your counters moving smoothly. It reduces long queues,
            speeds up service, and ensures accurate billing every time. Your
            staff can focus on serving customers while errors and delays are
            minimized. Enjoy a seamless, stress-free checkout experience that
            keeps your customers happy.
          </p>

          {/* INFO ROW */}
          <div className="montserrat-font-2 info-row flex flex-col md:flex-row gap-6">
            <div className="info-box flex-1 bg-[#0C4D45] text-white p-6 rounded-xl">
              <h4 className="text-lg font-semibold mb-2">Before</h4>
              <p className="text-sm leading-relaxed">
                Billing was slow and error-prone, with long queues frustrating
                customers.
              </p>
            </div>

            <div className="info-box flex-1 bg-[#0C4D45] text-white p-6 rounded-xl">
              <h4 className="text-lg font-semibold mb-2">Now</h4>
              <p className="text-sm leading-relaxed">
                Billing is instant and accurate, reducing wait times and errors.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstantBilling;
